import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { FlexLeagueMatchCard } from '../../../components/cards';
import SectionHeading from '../../../components/text/SectionHeading';
import SectionHeadingWrapper from '../../../components/text/SectionHeading/HeadingWrapper';
import { MatchFormatTypes } from '../../../utils/postScoreConstants';
import * as postScoreActions from '../../../actions/post-score-actions';

const FlexLeagueMatchCards = ({ flexLeagueMatchCards, auth, redirectUrl }) => {
    const [showAll, setShowAll] = useState();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(postScoreActions.setRound({ redirectUrlPage: 'FlexLeagues' }));
    }, []);

    const getGameType = (position1, position2) => {
        if (position1?.memberIds?.length > 1 || position2?.memberIds?.length > 1) {
            return MatchFormatTypes.DOUBLES;
        }
        return MatchFormatTypes.SINGLES;
    };
    return (
        <>
            {(flexLeagueMatchCards?.length > 0) ? (
                <>
                    <div className="row mt64">
                        <div className="col-12">
                            <SectionHeadingWrapper>
                                <SectionHeading title={'My matches (action required)'} subtext={'These are matches that need to be scheduled, scores posted, or confirmed'} data-testid="dashboard.flex-league-match-cards.section-heading" />
                                {flexLeagueMatchCards?.length > 6 && (
                                    <div className={`link clickable`} onClick={() => setShowAll(!showAll)} data-testid="dashboard.flex-league-match-cards.view-toggle">
                                        {showAll ? 'View Less' : 'View All'}
                                    </div>
                                )}
                            </SectionHeadingWrapper>
                        </div>
                    </div>
                    <div className="row mb64">
                        {flexLeagueMatchCards.map((flexLeagueMatchCard, i) => {
                            if (i < 6 || showAll) {
                                return (
                                    <div className={`col-12 col-md-6 col-xl-4`} key={`${flexLeagueMatchCard.id}`}>
                                        <FlexLeagueMatchCard
                                            key={`pending-match-item-${flexLeagueMatchCard.id}`}
                                            {...flexLeagueMatchCard}
                                            gameType={getGameType(flexLeagueMatchCard?.position1, flexLeagueMatchCard?.position2)}
                                            playerId={auth.user.claimedPlayer.playerId}
                                            timeZoneValue={'UTC'}
                                            showVerified={false}
                                            forceCardView={true}
                                            matchId={flexLeagueMatchCard?.id}
                                            redirectUrl={redirectUrl}
                                            data-testid={`dashboard.flex-league-match-cards.item-${flexLeagueMatchCard.id}`}
                                        />
                                    </div>
                                );
                            }
                            return <div />;
                        })}
                    </div>
                </>
            ) : null}
        </>
    );
};

FlexLeagueMatchCards.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
};

export default FlexLeagueMatchCards;
